import { EMAIL_REGEX, MOBILE_REGEX, PASSWORD_REGEX } from "./regex";

const validationMessages = {
    fname: "First Name is required",
    lname: "Last Name is required",
    email: "Email is required",
    password: "Password is required",
    mobile: "Mobile number is required",
    otp: "OTP is required",
    country: "Country is required",
    country_code: "Country code is required",
    // companyName: "IB Name is required",
    ibname: "IB Name is required",
    yearofexp: "Year of Experience is required",
    existclients: "Existing clients count is required",
    avgvolume: "Average volume is required",
};

export const validateRegisterFields = (input, showIBFields, ibData) => {
    const errors = {};

    if (!input.fname?.trim()) errors.fname = validationMessages.fname;
    if (!input.lname?.trim()) errors.lname = validationMessages.lname;
    if (!input.email?.trim()) errors.email = validationMessages.email;
    if (!input.password?.trim()) errors.password = validationMessages.password;
    if (!input.country?.trim()) errors.country = validationMessages.country;
    if (!input.country_code?.trim())
        errors.country_code = validationMessages.country_code;
    if (!input.mobile?.trim()) errors.mobile = validationMessages.mobile;

    if (input.email && !EMAIL_REGEX.test(input.email))
        errors.email = "Enter a valid email address.";
    // if (input.mobile && !MOBILE_REGEX.test(input.mobile))
    //     errors.mobile = "Mobile number must be valid lenght.";
    if (input.password) {
        if (input.password.length < 8)
            errors.password = "Password must be at least 8 characters.";
        else if (!PASSWORD_REGEX.test(input.password))
            errors.password =
                "Password must include uppercase, lowercase, number, and special character.";
    }

    if (showIBFields) {
        if (!ibData.ibname?.trim())
            errors.ibname = validationMessages.ibname;
        // errors.companyName = validationMessages.companyName;
        if (!ibData.yearofexp?.toString().trim())
            errors.yearofexp = validationMessages.yearofexp;
        if (!ibData.existclients?.toString().trim())
            errors.existclients = validationMessages.existclients;
        if (!ibData.avgvolume?.toString().trim())
            errors.avgvolume = validationMessages.avgvolume;
    }

    return errors;
};

export const validateOTP = (otp) => {
    if (!otp?.trim()) return { otp: validationMessages.otp };
    if (otp.length !== 6) return { otp: "OTP must be 6 digits" };
    return {};
};
